// storageCleaner.js
'use strict';
import { persist as persistDebug } from '../resource/debug.js';

const log = persistDebug.extend('storageCleaner');

const DEPRECATED_INDEXED_DB_NAME = 'workbox-expiration';

const indexedDBCleaner = async () => {
  try {
    const { default: localforage } = await import('localforage');

    await localforage.dropInstance({
      name: DEPRECATED_INDEXED_DB_NAME,
    });

    await new Promise((resolve, reject) => {
      const deleteRequest = indexedDB.deleteDatabase(
        DEPRECATED_INDEXED_DB_NAME
      );
      deleteRequest.onerror = () => {
        reject(`${DEPRECATED_INDEXED_DB_NAME} delete error`);
      };

      deleteRequest.onsuccess = () => {
        log('indexedDBCleaner success');
        resolve();
      };

      deleteRequest.onblocked = () => {
        reject(`${DEPRECATED_INDEXED_DB_NAME} delete blocked`);
      };
    });
  } catch (e) {
    log('indexedDBCleaner error', e);
  }
};

const cacheStorageCleaner = async () => {
  try {
    const { CACHE_NAME } = await import('../serviceWorker/persist.js');

    const storageList = await caches.keys();

    await Promise.all(
      storageList
        .filter(storageName => storageName !== CACHE_NAME)
        .map(storageName => caches.delete(storageName))
    );

    log('cacheStorageCleaner success');
  } catch (e) {
    log('cacheStorageCleaner error', e);
  }
};

/**
 * Storage cleaner
 */
const storageCleaner = () => {
  indexedDBCleaner();
  cacheStorageCleaner();
};

export default storageCleaner;
